// 全局图片缓存工具
class ImageCache {
  constructor() {
    this.cache = new Map();
    this.loadingCache = new Map(); // 缓存正在加载的图片
  }

  // 获取图片URL，如果已缓存则直接返回
  getImageUrl(content, messageId) {
    const cacheKey = messageId || this.generateKey(content);

    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey);
    }

    try {
      const parsedContent =
        typeof content === "string" ? JSON.parse(content) : content;
      const imageUrl = parsedContent.thumbUrl || parsedContent.originUrl;

      if (imageUrl) {
        this.cache.set(cacheKey, imageUrl);
        return imageUrl;
      }
    } catch (e) {
      console.warn("Failed to parse image content:", e);
    }

    return "";
  }

  // 预加载图片
  preloadImage(url) {
    if (!url || this.loadingCache.has(url)) {
      return Promise.resolve();
    }

    this.loadingCache.set(url, true);

    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        this.loadingCache.delete(url);
        resolve();
      };
      img.onerror = () => {
        this.loadingCache.delete(url);
        resolve();
      };
      img.src = url;
    });
  }

  // 清理缓存
  clearCache() {
    this.cache.clear();
    this.loadingCache.clear();
  }

  // 生成缓存key
  generateKey(content) {
    return typeof content === "string" ? content : JSON.stringify(content);
  }
}

// 创建全局实例
const imageCache = new ImageCache();

export default imageCache;
